import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

export type SpinnerProps = {
  size?: 'sm' | 'default' | 'lg';
  className?: string;
};

/**
 * A spinner component that follows the Shadcn UI design system.
 * It uses the Loader2 icon from Lucide React with a spinning animation.
 */
export function Spinner({ size = 'default', className }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label="Loading"
      className={cn(
        'animate-spin text-muted-foreground',
        {
          'h-4 w-4': size === 'sm',
          'h-6 w-6': size === 'default',
          'h-8 w-8': size === 'lg',
        },
        className,
      )}
    />
  );
}
